<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>

      <!--  ROW    -->
      <div class="vx-row mb-1" >
        <div class="vx-col  w-full">
          <vs-input
            v-on:keydown.enter="createGroup"
            class="w-full my-2"
            label="Name"
            v-model="newGroup.division_name"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full my-2 mb-2">
          <vs-button class="mx-1 w-full" @click="createGroup">Create Group</vs-button>
        </div>
      </div>

    </div>


</template>

<script>
  import types from '@/models';
  import api from '@/http/api';

  export default {
    data() {
      return {
        newGroup: new types.CompanyGroup(),
      }
    },
    props: {
      company: {
        type: types.Company(),
        required: true,
        default: () => {
          return new types.Company()
        }
      },
    },
    methods: {
      async createGroup() {
        this.$vs.loading();
        this.newGroup.parent_company_id = this.company.company_id;

        let newGroup = await api.createCompanyProductGroup(this.newGroup);

        this.$vs.loading.close();

        if (newGroup === null) {
          this.showNotification(false, 'error creating group');
          return;
        }

        this.$emit('groupCreated', newGroup);

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
</style>
